<div class="items-margin">
  <span class="sub-header">Target Price Consensus</span>
  <div
    class="out-of"
    *ngIf="TPConsensusDataReady && !hasConsensus && !totalBroker"
  >
    - / - Brokers
  </div>
  <div
    class="out-of"
    *ngIf="
      TPConsensusDataReady &&
      !hasConsensus &&
      totalBroker &&
      (!brokerInTPConsensus || brokerInTPConsensus < 3)
    "
  >
    - / {{ totalBroker }} Brokers
  </div>
  <div class="no-consensus-msg" *ngIf="TPConsensusDataReady && !hasConsensus">
    Too few target prices to calculate consensus.
  </div>

  <div class="out-of" *ngIf="hasConsensus">
    {{ brokerInTPConsensus || "-" }} / {{ totalBroker }} Brokers
  </div>
</div>

<ng-template #hypenTemplate>
  <div>-</div>
</ng-template>
<ng-container *ngIf="data">
  <div class="items-margin">
    <div class="items">
      <div class="letters">Consensus</div>
      <div
        *ngIf="
          hasConsensus && (data.target_price || data.target_price == 0);
          else hypenTemplate
        "
        [ngClass]="getClassOfTargetPrice(data.target_price)"
        class="numbers"
      >
        {{ curreny_symbol }}{{ data.target_price.toFixed(2) }}
      </div>
    </div>
    <div class="items">
      <div class="letters">Current Implied Return</div>
      <div
        *ngIf="
          hasConsensus &&
            (data.current_implied_return ||
              current_implied_return_display == 0);
          else hypenTemplate
        "
        [ngClass]="getClassOf(data.current_implied_return)"
        class="numbers"
      >
        <span class="signs" *ngIf="data.current_implied_return < 0">-</span>
        <span>{{ current_implied_return_display.toFixed(2) }}%</span>
      </div>
    </div>
  </div>
  <div class="items-margin">
    <div class="items">
      <div class="letters">Previous Close</div>
      <div
        *ngIf="data.prev_close || data.prev_close == 0; else hypenTemplate"
        class="numbers"
      >
        {{ curreny_symbol }}{{ data.prev_close.toFixed(2) }}
      </div>
    </div>
    <div class="items">
      <div class="letters">LTM Return</div>
      <div
        *ngIf="data.LTM_return || lTM_return_display == 0; else hypenTemplate"
        [ngClass]="getClassOf(data.LTM_return)"
        class="numbers"
      >
        <span class="signs" *ngIf="data.LTM_return < 0">-</span>
        <span>{{ lTM_return_display.toFixed(2) }}%</span>
      </div>
    </div>
  </div>
</ng-container>
